// src/Payroll_Management/PayRoll_Report/RemarksViewPrint.jsx
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const BASE_URL = "http://nissi-india.com";

function s(v) {
  return (v ?? "").toString().trim();
}

const RemarksViewPrint = () => {
  const [searchParams] = useSearchParams();

  const finYearId = localStorage.getItem("finYearId") || "";
  const employeeId = searchParams.get("employeeId") || "";

  const [loading, setLoading] = useState(true);
  const [row, setRow] = useState(null);

  const fetchData = async () => {
    if (!s(finYearId) || !s(employeeId)) {
      setLoading(false);
      return;
    }

    try {
      const res = await axios.get(
        `${BASE_URL}/api/performance-remarks-report/remark-details`,
        {
          params: {
            finYearId: Number(finYearId),
            employeeId: Number(employeeId),
          },
        }
      );

      if (res?.data?.success) {
        setRow(res.data.row || null);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    setTimeout(() => {
      window.print();
    }, 500);
    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ fontFamily: "Arial", padding: 20 }}>

      {/* ================= PRINT STYLE ================= */}
      <style>{`
        @media print {
          @page { size: A4; margin: 10mm; }
          .no-print { display: none !important; }
        }

        .outer-border {
          border: 2px solid #000;
          padding: 10px;
        }

        .inner-border {
          border: 1px solid #000;
          padding: 15px;
        }

        .logo-box {
          width: 110px;
          height: 90px;
          border: 1px solid #000;
        }

        .company-title {
          text-align: center;
          font-size: 22px;
          font-weight: bold;
        }

        .company-subtitle {
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          margin-top: 4px;
        }

        .company-address {
          text-align: center;
          font-size: 12px;
          margin-top: 6px;
        }

        .divider {
          border-top: 1px solid #000;
          margin-top: 10px;
        }

        .report-title {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin-top: 10px;
        }

        .content-box {
          border: 1px solid #000;
          padding: 15px;
          margin-top: 15px;
        }

        .row-grid {
          display: grid;
          grid-template-columns: 220px 1fr;
          gap: 8px;
          margin-bottom: 10px;
        }

        .label {
          font-weight: bold;
        }

        .footer {
          margin-top: 15px;
          border: 1px solid #000;
          text-align: center;
          font-size: 12px;
          padding: 8px;
        }
      `}</style>

      {/* ================= BUTTONS ================= */}
      <div className="no-print" style={{ textAlign: "right", marginBottom: 10 }}>
        <button
          onClick={() => window.print()}
          style={{ padding: "6px 12px", marginRight: 6, background: "black", color: "white" }}
        >
          Print
        </button>
        <button
          onClick={() => window.close()}
          style={{ padding: "6px 12px" }}
        >
          Close
        </button>
      </div>

      {/* ================= HEADER ================= */}
      <div className="outer-border">
        <div className="inner-border">

          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="logo-box"></div>

            <div style={{ flex: 1 }}>
              <div className="company-title">
                Nissi Infotech
              </div>

              <div className="company-subtitle">
                CIVIL CONSTRUCTION
              </div>

              <div className="company-address">
                3/42-12, Nagappa colony, Kavundampalayam, Coimbatore - 641030, Tamil Nadu.<br/>
                Phone No : 9003744644<br/>
                infraconsoft-implementations
              </div>
            </div>
          </div>

          <div className="divider"></div>

          <div className="report-title">
            EMPLOYEE REMARKS REPORT
          </div>

        </div>

        {/* ================= CONTENT ================= */}
        {loading ? (
          <div className="content-box">Loading...</div>
        ) : !row ? (
          <div className="content-box">No Records Found</div>
        ) : (
          <div className="content-box">

            <div className="row-grid">
              <div className="label">Employee Code</div>
              <div>: {row.fld_Employeecode}</div>

              <div className="label">Employee Name</div>
              <div>: {row.fld_Employee}</div>

              <div className="label">Designation</div>
              <div>: {row.fld_designationname}</div>

              <div className="label">Branch</div>
              <div>: {row.fld_BranchName}</div>

              <div className="label">Title</div>
              <div>: {row.fld_Title}</div>

              <div className="label">Details</div>
              <div>: {row.fld_Details}</div>
            </div>

          </div>
        )}

        {/* ================= FOOTER ================= */}
        <div className="footer">
          Report generated by ERP-Software - www.infraconsoft.com owned by www.nissiinfotech.com
        </div>
      </div>
    </div>
  );
};

export default RemarksViewPrint;
